// Import interfaces from typings
import { ToolItem, ResourceItem } from '../typings/home';

// Tools data
export const toolsData: ToolItem[] = [
  {
    id: 'setting-generator',
    heading: "Setting generator",
    text: "The AdskDeviceSettingGeneratorTool helps administrators securely deploy configurations across local workstations, ensuring only authorized machines apply the correct SecureSite Settings.",
    buttonText: "Download",
    buttonLink: "https://emsfs.autodesk.com/utility/dstg/1/installer/latest/AdskDeviceSettingGeneratorTool.exe",
    buttonVariant: "link-button",
    onButtonClick: () => {}
  },
  {
    id: 'dev-toolset',
    heading: "Developer Toolset",
    text: "A component that provides SecureSite settings at install-time and run-time. If customers are having issues with settings on a device, installing this latest version may help.",
    buttonText: "Download",
    buttonLink: "https://emsfs.autodesk.com/utility/devtoolset/1/installer/latest/Devtoolset.exe",
    buttonVariant: "link-button",
    onButtonClick: () => {}
  }
];

// Resources data
export const resourcesData: ResourceItem[] = [
  {
    id: 'config-guide',
    title: "Configuration Guide for Settings generator",
    link: "https://autodesk.atlassian.net/wiki/spaces/WGMN/pages/581478712/Customer-Facing+Guidelines+for+Secure+Site+Settings"
  },
  {
    id: 'setup-instructions',
    title: "Setup Instructions for Account user",
    link: "https://autodesk.atlassian.net/wiki/spaces/WGMN/pages/581479497/Team+GuideLines+for+Dark+Sky+Web+Portal"
  },
  {
    id: 'advanced-config',
    title: "Advanced Configuration for DOD Accounts",
    link: "#"
  }
];
